import React from "react";
import { useLocation } from "react-router-dom";
import useStore from "../../lib/store";
import { getRouteBuffer } from "../../lib/navigation";

const StatusLine = () => {
  const location = useLocation();
  const { mode, keyboardNav, toggleKeyboardNav, theme, toggleTheme } =
    useStore();
  const buffer = getRouteBuffer(location.pathname);
  const path = `portfolio/${buffer}`;

  return (
    <footer className="statusline" aria-label="Status line">
      <span className="statusline-mode">{mode}</span>
      <span className="statusline-path" title={path}>
        {path}
      </span>
      <span className="statusline-meta">
        <button
          type="button"
          className={
            "statusline-keymap" + (keyboardNav ? " on" : "")
          }
          onClick={toggleKeyboardNav}
          title="Toggle keyboard navigation (Vim-style)"
        >
          keymap:{keyboardNav ? "on" : "off"}
        </button>
        <button
          type="button"
          className="statusline-theme"
          onClick={toggleTheme}
          title="Toggle theme (dark/light)"
        >
          theme:{theme}
        </button>
        <span className="statusline-tech">Rust</span>
        <span className="statusline-branch">main</span>
        <span className="statusline-version">v0.1.0</span>
      </span>
    </footer>
  );
};

export default StatusLine;